import React, { type ReactNode } from 'react';
import { Icon } from '@/components/Icons';
import { ChevronRight } from '@/components/Icons/ChevronRight';
import { IconType } from '@/types/components';

interface BaseProps {
  icon: IconType;
  title: string;
  subtitle?: string;
  hasPaddedIcon?: boolean;
}

interface NavigationProps extends BaseProps {
  onClick?: () => void;
  trailing?: never;
}

interface CustomTrailingProps extends BaseProps {
  trailing: ReactNode;
  onClick?: never;
}

type Props = NavigationProps | CustomTrailingProps;

const ROW = 'flex w-full items-center gap-3 p-4 text-left';

export const Cell: React.FC<Props> = ({
  icon,
  title,
  subtitle,
  hasPaddedIcon = false,
  trailing,
  onClick,
}) => {
  const content = (
    <>
      <Icon
        icon={icon}
        className={`shrink-0 text-primary ${hasPaddedIcon ? '-m-0.5 size-5' : 'size-4'}`}
      />
      <div className="flex min-w-0 flex-1 flex-col gap-[2px]">
        <span className="text-body-16 text-foreground">{title}</span>
        {subtitle && (
          <span className="truncate text-body-13 text-subtle-foreground">
            {subtitle}
          </span>
        )}
      </div>
      {trailing && (
        <span className="flex shrink-0 items-center justify-center">
          {trailing}
        </span>
      )}
      {!trailing && (
        <ChevronRight
          strokeWidth="2"
          className="size-3.5 shrink-0 text-foreground"
        />
      )}
    </>
  );

  if (trailing) {
    return <div className={ROW}>{content}</div>;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${ROW} cursor-pointer transition-colors hover:bg-hover active:bg-on-primary-surface`}
    >
      {content}
    </button>
  );
};
